import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import RaisedHandIcon from '../../../images/vector/raised-hand.svg';
import { DEFAULT_HELP_POPUP_TITLE } from '../../../constants/error';

const HelpPopup = ({ className, children, problem, buttons, icon, title, hasVerticalLayout }) => (
    <div className="dim-layout">
        {hasVerticalLayout ? (
            <div className={classNames('help-popup modal', className)}>
                <div className="title">{title}</div>
                <div className="help-icon">{icon}</div>
                <hr />
                <div className={`content ${title ? '' : 'shifted'}`}>
                    <div className="problem">{problem}</div>
                    {children}
                    {buttons && (
                        <div className={`popup-buttons ${title ? '' : 'shifted'}`}>{buttons}</div>
                    )}
                </div>
            </div>
        ) : (
            <div className={classNames('help-popup modal', className)}>
                <div className="top-area">
                    <div className="help-icon">{icon}</div>
                    <div className="right-side">
                        <div className="title">{title}</div>
                        <div className="problem">{problem}</div>
                    </div>
                </div>
                <div className="content">{children}</div>
            </div>
        )}
    </div>
);

HelpPopup.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.string,
    problem: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.element]),
    buttons: PropTypes.arrayOf(PropTypes.element),
    className: PropTypes.string,
    hasVerticalLayout: PropTypes.bool,
};

HelpPopup.defaultProps = {
    title: DEFAULT_HELP_POPUP_TITLE,
    icon: <RaisedHandIcon />,
    children: undefined,
    buttons: undefined,
    className: '',
    hasVerticalLayout: true,
};

export default HelpPopup;
